import Vue from 'vue';
import nprogress from 'nprogress';
import VueRouter from 'vue-router';
import {
	routes
} from './router.js'
Vue.use(VueRouter)
const router = new VueRouter({
	routes
})
// 路由导航守卫
router.beforeEach((to, from, next) => {
	nprogress.start()
	document.title = to.meta.title;
	next()
})
router.afterEach((to, from) => {
	nprogress.done();
})
export default router